import {Component, OnInit,inject, DestroyRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SolutionsService} from '../../../services/api/solutions.service';
import {BlueprintsService} from '../../../services/api/blueprints.service';
import {AuthService} from '../../../services/auth/auth.service';
import {ErrorPageService} from '../../../services/util/error-page.service';
import {PermissionsService} from '../../../services/util/permissions.service';
import {combineLatest} from 'rxjs';
import {tap} from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {Instance} from '../../../models/instance/instance';
import {Blueprint, BlueprintTypes} from '../../../models/blueprints/blueprint';
import {translate} from '@jsverse/transloco';
import {CapabilitiesGroup, Capability, CapabilityType} from '../../../models/service/capability';
import {Solution} from '../../../models/service/solution';
import {SolutionVersion} from '../../../models/service/solution-version';
import {BreadcrumbItem} from '../../../models/breadcrumb/breadcrumb-item';
import {RouterSegments} from '../../../models/router-segments';
import {Permission} from '../../../models/principal/permission';
import {ToastrService} from '../../../services/util/toastr.service';
import {CreateSandboxDialogComponent} from '../create-sandbox-dialog/create-sandbox-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {DeployStatus} from '../../../models/deploy/deploy-status';
import {DataZone} from '../../../models/data-zone/data-zone';
import {DeploymentClass} from '../../../models/instance-class';
import {Deployment} from '../../../models/deploy/deployment';
import {ErrorDialogComponent} from '../../../components/error-dialog/error-dialog.component';
import {InstancesService} from '../../../services/api/instances.service';
import {Sandbox} from '../../../models/sandbox';
import {TrialStatusService} from '../../../services/util/trial-status.service';
import { Title } from '@angular/platform-browser';

const REQUIRED_PERMISSIONS = [
  Permission.CREATE_SANDBOX,
  Permission.CREATE_SERVICE_DEFINITION,
  Permission.VIEW_ENTERPRISE,
];

@Component({
    selector: 'app-service-definition-version',
    templateUrl: './service-definition-version.component.html',
    styleUrls: ['./service-definition-version.component.scss'],
    standalone: false
})
export class ServiceDefinitionVersionComponent implements OnInit {

  dataLoaded = false;
  service: Solution;
  servicesVersionsMap = new Map<string, SolutionVersion[]>();
  capabilitiesGroups: CapabilitiesGroup[];
  CapabilityType = CapabilityType;
  selectedCapabilitiesArr = [];
  demoInstance: Instance;
  blueprint: Blueprint;
  isDemoBlueprint: any;
  blueprintLatestVersion: any;
  UpdateExtendService: boolean;
  UpdateExtendServiceDisable: boolean;
  selectedCapabilitiesLength = [];
  blueprints: Blueprint[];
  instances: Instance[];
  RouterSegments = RouterSegments;
  tenant: string;
  breadcrumbItems: BreadcrumbItem[];
  permissionsMap: { [key: string]: boolean };
  capabilities: any;
  selectedCapabilities: any[];
  displayStartFreeTrialButton: boolean;
  latestSolutionVersionId: any;
  serviceId: any;
  capabilityDescription: Capability[];
  sandboxLoader = false;
  instanceId: string;
  blueprintId: any;
  sandbox: Sandbox;
  trialStatus: string;
  instanceStatus: DeployStatus;
  descriptionArray: any;
  errorMessage: any;
  blueprintData: any;
  solutionVersion: any;
  instanceSolutionVersion: string;
  mainArray: any;
  additionalIncluded = [];
  additionalOptional = [];
  includedCapabilities: any;
  optionalCapabilities: any;
  private destroyRef = inject(DestroyRef);

  readonly statusInfo: { [key: string]: any } = {
    [DeployStatus.DEPLOYED]: {icon: 'done', colorClass: 'green-1-bg'},
    [DeployStatus.DEPLOYING]: {icon: 'done', colorClass: 'green-1-bg'},
    [DeployStatus.FAILED]: {icon: 'close', colorClass: 'warn-solid-bg'},
    [DeployStatus.TERMINATING]: {icon: 'change_circle', colorClass: 'accent-1-bg'},
    [DeployStatus.TERMINATION_FAILED]: {icon: 'error_outline', colorClass: 'warn-solid-bg'},
    [DeployStatus.NOT_DEPLOYED]: {icon: 'close', colorClass: 'neutral-blue-6-bg'},
    [DeployStatus.UPDATED]: {icon: 'done', colorClass: 'green-1-bg'},
    [DeployStatus.UPDATE_FAILED]: {icon: 'close', colorClass: 'warn-solid-bg'}
  };
  DeployStatus = DeployStatus;
  createdCapabilities = [];

  constructor(
    private matDialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    private solutionsService: SolutionsService,
    private blueprintsService: BlueprintsService,
    private authService: AuthService,
    private errorPageService: ErrorPageService,
    private permissionsService: PermissionsService,
    private instancesService: InstancesService,
    private trialStatusService: TrialStatusService,
    private readonly titleService: Title,
  ) {
  }

  ngOnInit(): void {
    this.instanceSolutionVersion = localStorage.getItem('instanceSolutionVersion');
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    this.tenant = this.authService.principal.provider;
    this.loadData();
  }

  loadData(): void {
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    const serviceId = this.activatedRoute.snapshot.params.serviceId;
    this.blueprintsService.getBlueprintVersion(blueprintId).subscribe(data=>{
      this.blueprintData = data[0]?.runningSolutionVersionId;
    });
    combineLatest([this.solutionsService.getSolutionDetailsById(serviceId),
      this.solutionsService.getSolutionVersions(serviceId),
      this.blueprintsService.getBlueprintVersion(blueprintId)
    ])
      .pipe(
        tap(([service, serviceVersions]) => {
          let findVersion;
          if(!this.instanceSolutionVersion || this.instanceSolutionVersion === 'undefined') {
            findVersion =  serviceVersions.find(item => item.id === service.latestSolutionVersionId);
          } else {
            findVersion =  serviceVersions.find(item => item.id === this.instanceSolutionVersion);
          }
          // eslint-disable-next-line max-len
          this.loadCapabilitiesDescription(serviceId, (this.instanceSolutionVersion === 'undefined') ? service.latestSolutionVersionId : this.instanceSolutionVersion);
          this.service = service;
          this.capabilities = findVersion.capabilities;
          this.mainArray = findVersion.capabilities;
            findVersion?.capabilities?.forEach(element => {
              if(element?.nested) {
                element.hasNested = true;
                element?.nested.forEach(data => {
                  this.mainArray = this.mainArray.filter(item => item?.name !== data);
                });
              }
            });
            this.mainArray.forEach(element => {
              let nestedObj = [];
              let obj = {};
              if(element?.nested) {
                element?.nested.forEach(innerElement=> {
                  if (findVersion?.capabilities?.find(item => item.name === innerElement)) {
                    obj = findVersion?.capabilities?.find(item => item.name === innerElement);
                  } else {
                    obj = {
                      name: innerElement
                    };
                  }
                  nestedObj = [...nestedObj, obj];
                });
                element.nestedObj = nestedObj;
              }
            });
          this.capabilities = this.mainArray;
          if (this.capabilities?.length > 0) {
            this.capabilities.reduce((acc, capability) => {
              if (capability.required !== CapabilityType.OPTIONAL) {
                capability.selected = true;
              }
              return acc;
            }, {});
          }
          this.includedCapabilities = this.mainArray?.filter(item => item?.required === CapabilityType.MANDATORY);
          this.optionalCapabilities = this.mainArray?.filter(item => item?.required === CapabilityType.OPTIONAL);
          if (!this.mainArray || this.mainArray?.length === 0) {
            this.includedCapabilities = [];
            this.optionalCapabilities = [];
          }
          this.servicesVersionsMap.set(this.service.id, serviceVersions);
          this.configureBreadcrumb(service);
          this.titleService.setTitle(this.service?.name);
          this.loadBlueprint();
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.dataLoaded = true;
      }, error => {
        this.errorPageService.show404Page();
      });
  }

  loadCapabilitiesDescription(serviceId, latestSolutionVersionId): Promise<any> {
    return new Promise((resolve) => {
      this.solutionsService.getSolutionVersion(serviceId, latestSolutionVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(serviceDetails => {
        this.solutionVersion = serviceDetails;
        this.solutionVersion = serviceDetails;
        this.mainArray = this.solutionVersion.capabilities;
        this.solutionVersion?.capabilities?.forEach(element => {
          if(element?.nested) {
            element.hasNested = true;
            element?.nested.forEach(capablityiesDta => {
              this.mainArray = this.mainArray.filter(item => item?.name !== capablityiesDta);
            });
          }
        });
        this.mainArray.forEach(element => {
          let nestedObj = [];
          let obj = {};
          if(element?.nested) {
            element?.nested.forEach(innerElement=> {
              if (this.solutionVersion?.capabilities?.find(item => item.name === innerElement)) {
                obj = this.solutionVersion?.capabilities?.find(item => item.name === innerElement);
              } else {
                obj = {
                  name: innerElement
                };
              }
              nestedObj = [...nestedObj, obj];
            });
            element.nestedObj = nestedObj;
          }
        });

        this.includedCapabilities = this.mainArray?.filter(item => item?.required === CapabilityType.MANDATORY);
        this.optionalCapabilities = this.mainArray?.filter(item => item?.required === CapabilityType.OPTIONAL);
        if (!this.mainArray || this.mainArray?.length === 0) {
          this.includedCapabilities = [];
          this.optionalCapabilities = [];
        }
        this.capabilities = [...this.includedCapabilities, ...this.optionalCapabilities];
        this.capabilityDescription = this.capabilities;
          resolve(serviceDetails.capabilities);
        }, (error) => {
        resolve(error);
      });
    });
  }

  getSelectedCapabilities(): any[] {
    const selectedCapabilities = [];
    const selectedCapabilitiesByName = [];
    if (this.capabilities && this.capabilities.length > 0) {
      this.capabilities.filter((x) => {
        if (x?.selected || x?.hasNested) {
          if (x?.nestedObj) {
            x.nestedObj.forEach(element => {
              element.selected = true;
            });
          }
          selectedCapabilities.push(x);
          selectedCapabilitiesByName.push(x.name);
        }
      });
    }
    localStorage.setItem('selectedCapabilities', JSON.stringify(selectedCapabilities));
    return selectedCapabilitiesByName;
  }

  updateService(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.service.id,
      RouterSegments.SERVICE_DEFINITION, RouterSegments.EXTEND, this.activatedRoute.snapshot.params.blueprintId
    ], {state: {data: this.getSelectedCapabilities()}});
  }

  goBack(): void {
    this.router.navigate(['/', this.tenant, RouterSegments.SERVICES, this.service.id,
      RouterSegments.BLUEPRINTS, this.blueprint.id], {state: {data: BlueprintTypes.SERVICE_DEFINITION}});
  }

  selectionChanged(changedCapability: Capability): void {
    const selectedCapabilities = [];
    selectedCapabilities.push(changedCapability);
    this.toastrService.clear();
    this.toastrService.checkboxMessage(
      `${(changedCapability?.displayName)} ${changedCapability.selected ? 'Added' : 'Removed'}`
    );

    if (!this.activatedRoute.snapshot.params.blueprintId) {
      this.UpdateExtendService = false;
      this.UpdateExtendServiceDisable = false;
    } else {
      this.UpdateExtendService = true;
      this.UpdateExtendServiceDisable = true;
    }

    selectedCapabilities.reduce(
      (acc, capability, c) => {
        if (capability.selected === true && capability.required === CapabilityType.OPTIONAL) {
          capability.selected = true;
          this.selectedCapabilitiesArr.push(capability);
        } else {
          this.selectedCapabilitiesArr
            .reduce((cap, falseCapability) => {
              if (falseCapability.selected === false) {
                this.selectedCapabilitiesArr = this.selectedCapabilitiesArr.filter((x) => {
                  if (x.selected === true && x.required === CapabilityType.OPTIONAL) {
                    return x.selected === true;
                  }
                });
              }
              return cap;
            }, {});
        }
        return acc;
      }, {}
    );
  }

  resetSelection(): void {
    if (this.selectedCapabilitiesArr?.length > 0) {
      this.toastrService.checkboxMessage('Selected Capabilities Removed');
      this.selectedCapabilitiesArr = [];
    }
    this.capabilitiesGroups?.find(group => group.name === CapabilityType.OPTIONAL)?.capabilities?.forEach(capability => {
      if (capability?.selected === true && capability?.disabled !== true) {
        capability.selected = false;
      }
    });
  }

  titleCaseWord(word): any {
    if (!word) {
      return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  isUpdated(capability): boolean {
    if (this.selectedCapabilities) {
      return this.selectedCapabilities.some(e => e.name === capability.name);
    }
  }

  loadBlueprint(): void {
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    if (blueprintId) {
      this.UpdateExtendService = true;
      this.blueprintsService.getBlueprintsIdLatestVersion(blueprintId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        blueprintLatestVersion => {
          this.blueprintLatestVersion = blueprintLatestVersion;
          this.capabilities.forEach(element => {
            this.blueprintLatestVersion?.capabilities?.forEach(capability => {
              if(element?.name === capability?.name) {
                element.showAdditional = true;
              } else if(element?.name === capability?.name) {
                element.showAdditional = false;
              }
            });
            if (element.nestedObj) {
              element.nestedObj.forEach(item => {
                if (this.blueprintLatestVersion.capabilities.find(capability => capability.name === item.name)) {
                  item.selected = true;
                  item.disabled = true;
                  if(element.required === CapabilityType.MANDATORY) {
                  const selected = element.nestedObj?.filter(items => items?.selected === true);
                  this.additionalIncluded = [...selected];
                  element.selectedNestedObj = element.nestedObj.filter(items => items.selected);
                  } else if(element.required === CapabilityType.OPTIONAL) {
                    const selected = element.nestedObj?.filter(items => items?.selected === true);
                    this.additionalOptional = [...selected];
                    element.selectedNestedObj = element.nestedObj.filter(items => items.selected);
                  }
                }
              });
            }
          });
          const capabilitiesByTypes = this.blueprintLatestVersion.capabilities
          .reduce((bluePrintacc, bluePrintCapability) => {
            bluePrintacc = this.capabilities?.reduce((acc, capability) => {
              if (capability.required === CapabilityType.OPTIONAL && bluePrintCapability.name === capability.name) {
                capability.selected = true;
                capability.disabled = true;
              }
              let capabilitiesArr = acc[capability.required];
              if (capabilitiesArr == null) {
                capabilitiesArr = [];
                acc[capability.required] = capabilitiesArr;
              }
              capabilitiesArr.push(capability);
              return acc;
            }, {});
            if (bluePrintCapability.required === CapabilityType.OPTIONAL) {
              this.selectedCapabilitiesLength.push(bluePrintCapability);
            }
            return bluePrintacc;
          }, {});
          if (capabilitiesByTypes) {
            this.capabilitiesMapping(capabilitiesByTypes);
          }
          this.displayStartFreeTrialButton = true;
        }, (error) => {
          this.toastrService.clear();
              setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });

      this.blueprintsService.getBlueprint(blueprintId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(blueprint => {
          this.blueprint = blueprint;
          this.isDemoBlueprint = blueprint.demo;
          if (this.isDemoBlueprint) {
            this.loadInstances();
          }
        });
    }
  }

  loadInstances(): void {
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;

    this.instancesService.getInstancesForSolution(this.service.id)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instances: any) => {
        instances.filter((x) => {
          if (x.name === translate('BLUEPRINT_SUMMARY.DEMO_INSTANCE_SANDBOX') && x.blueprintId === this.blueprintId) {
            this.instanceId = x.id;
          }
        });

        this.sandbox = {
          service: this.service,
          instance: instances[0],
        };
        this.trialStatus = this.trialStatusService.TrailStatusUTCFormat(this.sandbox.instance);
        this.getInstanceStatus(this.sandbox.instance);
      });
  }

  getInstanceStatus(instance: Instance): void {
    const currentDate = +new Date();
    const instanceCreatedDate = new Date(instance.dateCreated);
    const maximumLoadingTime = instanceCreatedDate.setMinutes(instanceCreatedDate.getMinutes() + 5);
    if (currentDate > maximumLoadingTime && instance.status === DeployStatus.DEPLOYED) {
      this.instanceStatus = DeployStatus.DEPLOYED;
    } else {
      this.instanceStatus = DeployStatus.DEPLOYING;
    }
  }

  updateSandbox(): void {
    if(this.solutionVersion?.sandboxType && this.solutionVersion?.sandboxType === 'enterprise') {
        this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.service.id,
        RouterSegments.SERVICE_DEFINITION, RouterSegments.EXTEND, this.activatedRoute.snapshot.params.blueprintId
      ], {state: {data: this.getSelectedCapabilities(), sandbox: true }});
    } else {
    this.matDialog.open(CreateSandboxDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SOLUTION_SUMMARY.EXTEND_SANDBOX.EXTEND_SANDBOX'),
        serviceName: this.service?.name,
        punchline: this.service?.punchline,
        confirmButtonText: translate('BUTTONS.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.sandboxLoader = true;
          this.onUpdateSandbox();
        }
      }, (error) => {
        this.sandboxLoader = false;
      });
    }
  }

  onUpdateSandbox(): void {
    let deployment;
    const getSelectedCapabilities = [];
    const blueprint = {
      solutionId: this.service.id,
      name: this.service.name,
      demo: 'true'
    } as any;

    if (this.capabilities && this.capabilities.length > 0) {
      this.capabilities.filter((x) => {
        if (x.selected) {
          getSelectedCapabilities.push(x.name);
        }
      });
    }

    this.demoInstance = {
      status: DeployStatus.DEPLOYING
    } as Instance;

    const blueprintIds = this.activatedRoute.snapshot.params.blueprintId;

    this.blueprintsService.createBlueprintVersion(blueprintIds, getSelectedCapabilities)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (blueprintVersion: any) => {
        deployment = {
          blueprintId: blueprintIds,
          blueprintVersionId: blueprintVersion.id,
          region: this.service.regionalAvailability[0],
          dataZone: DataZone.DEVELOPMENT,
          deploymentClass: DeploymentClass.D,
          name: translate('BLUEPRINT_SUMMARY.DEMO_INSTANCE_SANDBOX'),
          capabilities: getSelectedCapabilities
        } as Deployment;
        this.instancesService.applyDefinition(blueprintVersion.id, this.instanceId)
          .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((deploymentINs) => {
          this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.service.id,
            RouterSegments.BLUEPRINTS, blueprintIds]);
        }, (error) => {
          this.deployInstanceError(error);
          // Remove demoInstance if deployment fail to avoid disabling the button.
          delete this.demoInstance;
        });
      }, (error) => {
        this.deployInstanceError(error);
        // Remove demoInstance if deployment fail to avoid disabling the button.
        delete this.demoInstance;
      });

  }

  deployInstanceError(error): void {
    this.sandboxLoader = false;
    this.matDialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '566px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('NOTIFICATIONS.SANDBOX_FAILED'),
        description: error,
      }
    });
  }

  private capabilitiesMapping(capabilitiesByType?: any): any {
    this.capabilitiesGroups = Object.keys(capabilitiesByType)
      .map(capabilityType => ({name: capabilityType, capabilities: capabilitiesByType[capabilityType]}));

    this.capabilitiesGroups?.find(group => group.name === CapabilityType.OPTIONAL)?.capabilities?.forEach(capability => {
      if (capability?.selected === true) {
        this.createdCapabilities?.push(capability);
      }
    });
  }

  private configureBreadcrumb(service: Solution): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({label: 'Home', url: []});
    // this.breadcrumbItems.push({label: translate('CATALOGUE.CATALOGUE'), url: ['catalogue']});
    // this.breadcrumbItems.push({label: service.name});
  }
}
